import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Line = ({
  height = 16,
  width = 8,
  color = colors.cyan100,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 8" {...props}>
    <path
      d="M1 5.8H3.97229C3.98953 5.8 4.00555 5.79112 4.01469 5.7765L5.45507 3.47189C5.47525 3.4396 5.52268 3.44082 5.54117 3.47411L7.4448 6.90064C7.46593 6.93867 7.52219 6.93344 7.53594 6.89217L9.46643 1.10071C9.4798 1.06059 9.53385 1.05416 9.55626 1.09002L10.9853 3.3765C10.9944 3.39112 11.0105 3.4 11.0277 3.4H15"
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
    />
  </SvgIcon>
);
